export default __webpack_public_path__ + "static/media/image.47a6c884.png";